import React, { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import defult from './default.jpg';
import { useStateContext } from '../../Contexts/ContextProvider';

const AddSpeaker = () => {
  const [uploading , setIsUploading] = useState(false) ;  
  const {id} = useParams() ;

  const { SetNotification } = useStateContext();
  const nameRef = useRef(null);
  const ar_nameRef = useRef(null);

  const descriptionRef = useRef(null);
  const ar_descriptionRef = useRef(null);

  const TitleRef = useRef(null);
  const ar_TitleRef = useRef(null);

  const [image_, setImage] = useState(defult);
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);

    const reader = new FileReader();

    reader.onload = (event) => {
      setImagePreviewUrl(event.target.result);
    };

    reader.readAsDataURL(selectedImage);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading (true) ; 
    const formData = new FormData();
    
    formData.append('name', nameRef.current.value);
    formData.append('title', TitleRef.current.value);
    formData.append('ar_name', ar_nameRef.current.value);
    formData.append('ar_title', ar_TitleRef.current.value);
    formData.append('conference_id', id);
    formData.append('description', descriptionRef.current.value);

    formData.append('ar_description', ar_descriptionRef.current.value);
    formData.append('image', image_);

    try {
      await AxiosClient.post('/speakers', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      SetNotification('speaker added successfully', 'success');
      navigate(-1);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.message) {
        SetNotification(error.response.data.message, 'danger');
        setIsUploading(false);
      } else {
        SetNotification('An error occurred while adding speaker.', 'danger');
        setIsUploading(false);

      }
    }
  };

  return (
    <div className="m-4">
      <form className="form-group">
        <h5>Name in English</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter name" ref={nameRef} />
        </div>

       
        <h5>Title</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" placeholder="Enter Title" ref={TitleRef} />
        </div>

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" placeholder="Enter description" rows={5} ref={descriptionRef} />
        </div>
        <div className='w-full border input-group input-group-outline p-2 form-control card'>
         
        <br/>
        <h5>Name in Arabic</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" dir="rtl" className="form-control" placeholder=" أدخل الاسم باللفةالعربية" ref={ar_nameRef} />
        </div>
        <h5>Arabic Title</h5>
        <div className="input-group input-group-outline mb-3">
          <input type="text" className="form-control" dir="rtl" placeholder="أدخل الصفة التي يحملها  " ref={ar_TitleRef} />
        </div>

        <h5>Arabic Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea className="form-control" dir="rtl" placeholder=" أكتب وصفاً ." rows={5} ref={ar_descriptionRef} />
        </div>
        </div>

        <h5>Image</h5>
        <div className="w-full flex flex-wrap items-center">
          <label htmlFor="imageUpload" className="w-full block mb-2 font-medium text-gray-700 m-2">
            speaker Image:
          </label>
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            onChange={handleImageChange}
            className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <img
          src={imagePreviewUrl ? imagePreviewUrl : defult}
          alt="Uploaded"
          style={{ maxWidth: '250px', maxHeight: '25%' }}
          className="w-full object-contain mb-w-100 text-center"
        />

        
     
      <br/>  
    { uploading? (<h4 className='text-red' > loading </h4> ) 
    : 
        <button onClick={handleSubmit} className="btn btn-info mt-3 px-5">
          <i className="material-icons mx-2">add_box</i>
          Submit
        </button>}
      </form>
    </div>
  );
};

export default AddSpeaker;
